import { Controller } from "@hotwired/stimulus";

// Reload form controller - triggers form reload for backoffice group forms
// Used for:
// - group_type changes (setApplyDefaultsAndSubmit)
// - license checkbox changes (requestSubmit)
// - date field blur events in new mode (requestSubmit)
// - start date changes in new mode (markStartDateChanged, then requestSubmit on blur)
export default class extends Controller<HTMLFormElement> {
  static targets = ["applyDefaults", "startDateChanged"];

  declare readonly hasApplyDefaultsTarget: boolean;
  declare readonly applyDefaultsTarget: HTMLInputElement;
  declare readonly hasStartDateChangedTarget: boolean;
  declare readonly startDateChangedTarget: HTMLInputElement;

  // Called by group_type radio buttons to apply defaults when group type changes
  setApplyDefaultsAndSubmit(): void {
    if (this.hasApplyDefaultsTarget) {
      this.applyDefaultsTarget.value = "true";
    }
    this.element.requestSubmit();
  }

  // Called on the start date's change event. Only marks the change: submitting
  // on change would reload the form while the year is still being typed, so
  // the submit happens on blur.
  markStartDateChanged(): void {
    if (this.hasStartDateChangedTarget) {
      this.startDateChangedTarget.value = "true";
    }
  }

  // Called by license checkboxes and date fields to trigger form reload
  // Uses requestSubmit() for proper Turbo compatibility (triggers validation and submit events)
  requestSubmit(): void {
    this.element.requestSubmit();
  }
}
